export const selectModalIsOpen = store => store.modal.modalProps.open;
export const selectModalType = store => store.modal.modalType;
export const selectModalProps = store => store.modal.modalProps;
